import { Component, HostListener, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { InboxSoundService } from './services/inbox-sound.service';
import { AppErrorService } from './core/services/app-error.service';
import { DocumentTitleService } from './core/services/document-title.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'pipeup.web';
  private soundUnlocked = false;
  readonly appError = inject(AppErrorService);

  constructor(
    private inboxSoundService: InboxSoundService,
    private documentTitleService: DocumentTitleService
  ) {
    this.documentTitleService.init();
    this.inboxSoundService.init();
  }

  onRetry(): void {
    this.appError.clearError();
    window.location.reload();
  }

  /** Primeira interação do usuário na aplicação: desbloqueia áudio para notificação de nova mensagem. */
  @HostListener('document:click')
  onDocumentClick(): void {
    if (!this.soundUnlocked) {
      this.soundUnlocked = true;
      this.inboxSoundService.unlockAudioOnUserInteraction();
    }
  }
}
